import axios from 'axios';
import {getHeaders} from '@core/actions/xhrRequest';

// Decision values mirror essay-db UpsellEventTypeEnum (accepted/skipped).
// Passed on the order form values as `upsellDecision`; getFormData maps
// them to order[upsell_decision], recorded into upsell_event on create.
export const UPSALE_ACCEPTED = 'accepted';
export const UPSALE_SKIPPED = 'skipped';

// Single source of truth for "is the upsell modal relevant for this order".
// Modal is pointless once the customer already has premium writer, a
// plagiarism report (paid or free), or picked a preferred writer.
export const shouldShowUpsale = values => !(
    values.authorCategory === 'Premium' ||
    values.plagiarismReport === 1 ||
    values.freeAuthorCategory === 'Free Premium' ||
    values.freePlagiarismReport === 1 ||
    !!values.preferredWriter
);

// Fire-and-forget impression ping — the funnel denominator (modal shown).
// Site/customer are derived server-side from the BFF auth headers, so the
// body is empty. Never let a dropped stat surface to the customer.
export function trackUpsaleImpression() {
    try {
        axios.post('/api/upsell-impression', {}, {headers: getHeaders(), timeout: 10000})
            .catch(() => {});
    } catch {
    }
}
